"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var StyledSVG = styled_components_1.default(function (props) {
    var Icon = props.icon, rest = tslib_1.__rest(props, ["icon"]);
    return react_1.default.createElement(Icon, tslib_1.__assign({}, rest));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n\n  .fill {\n    fill: ", ";\n  }\n\n  .stroke {\n    stroke: ", ";\n  }\n\n  ", "\n"], ["\n  height: ", ";\n  width: ", ";\n\n  .fill {\n    fill: ", ";\n  }\n\n  .stroke {\n    stroke: ",
    ";\n  }\n\n  ", "\n"])), function (props) { return props.height; }, function (props) { return props.width; }, function (props) { return (props.currentColor ? 'currentColor' : function (props) { return (props.fill ? function (props) { return props.fill; } : null); }); }, function (props) {
    return props.currentColor ? 'currentColor' : function (props) { return (props.stroke ? function (props) { return props.stroke; } : null); };
}, function (props) { return props.css; });
var StyledImg = styled_components_1.default.img(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n  ", "\n"], ["\n  height: ", ";\n  width: ", ";\n  ", "\n"])), function (props) { return props.height; }, function (props) { return props.width; }, function (props) { return props.css; });
var Icon = function (props) {
    var icon = props.icon, rest = tslib_1.__rest(props, ["icon"]);
    if (typeof icon === 'string') {
        return react_1.default.createElement(StyledImg, tslib_1.__assign({ src: icon, "aria-hidden": "true" }, rest));
    }
    return react_1.default.createElement(StyledSVG, tslib_1.__assign({}, props));
};
exports.Icon = Icon;
Icon.defaultProps = {
    height: '1em',
    width: '1em'
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Icon.js.map